export default "__VITE_ASSET__hh3Inxlw__"